import { render, staticRenderFns } from "./ReportImageTire.vue?vue&type=template&id=64d34203&scoped=true&"
import script from "./ReportImageTire.vue?vue&type=script&lang=ts&"
export * from "./ReportImageTire.vue?vue&type=script&lang=ts&"
import style0 from "./ReportImageTire.vue?vue&type=style&index=0&id=64d34203&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d34203",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
